import React from 'react';

interface Props {
    isDoseCalculatorAvailable: boolean;
    toggleIsDoseCalculatorAvailable: () => void;
}

const MedicationsOtherSettings: React.FC<Props> = ({
    isDoseCalculatorAvailable,
    toggleIsDoseCalculatorAvailable,
}) => {
    return (
        <div className="space-y-8">
            <div
                onClick={toggleIsDoseCalculatorAvailable}
                className="flex items-center justify-between px-12 py-10 bg-actionPrimary bg-opacity-10 rounded-8 cursor-pointer"
            >
                <p className="text-13 text-actionPrimary font-700">Pediatric Dose Calculator</p>
                <div>
                    <div className="flex items-center justify-center w-24 h-24">
                        {isDoseCalculatorAvailable ? (
                            <svg
                                className="w-20 h-20 fill-actionPrimary"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path>
                            </svg>
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                className="w-20 h-20 fill-neutral-3"
                            >
                                <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"></path>
                            </svg>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MedicationsOtherSettings;
